module.exports = __webpack_public_path__ + "static/media/thierry_kibagabaga1.0586fc37.jpg";